import PropTypes from "prop-types";
import { Modal } from "@/config/antd";
import Button from "@/components/common/Button";
import WarningGif from "@/assets/images/veegil_loader/Warning.gif";

const Delete = ({
  isVisible,
  onClose,
  onProceed,
  header,
  paragraph,
  proceedButtonText = "Delete",
  cancelButtonText = "Cancel",
}) => {
  return (
    <Modal
      open={isVisible}
      onCancel={null}
      closeIcon={null}
      footer={null}
      centered
      width={350}
      styles={{
        body: { padding: 0 },
        content: {
          padding: 0,
          borderRadius: "16px",
          overflow: "hidden",
        },
        mask: { backgroundColor: "rgba(0, 0, 0, 0.75)" },
      }}
      className="custom-delete-modal"
      data-testid="mock-modal">
      <div className="flex flex-col bg-white">
        <div className="p-6">
          <div className="mb-6 flex justify-center">
            <img
              src={WarningGif}
              alt="Delete Icon"
              style={{
                width: "200px",
                height: "200px",
                margin: "0 auto",
                display: "block",
              }}
            />
          </div>

          <h2 className="heading-regular font-semibold text-primary mb-3 whitespace-nowrap text-center">
            {header}
          </h2>

          <p
            className="text-regular text-center text-darkGray mb-2"
            dangerouslySetInnerHTML={{ __html: paragraph }}
          />
        </div>

        <div className="w-full bg-secondary p-4 flex flex-row items-center justify-between">
          <Button
            text={cancelButtonText}
            onClick={onClose}
            color="white"
            className="flex-1 mr-2 border border-primary text-primary"
            customBgColor="white"
            customTextColor="primary"
            data-testid={`button-${cancelButtonText
              .toLowerCase()
              .replace(/\s+/g, "-")}`}
          />
          <Button
            text={proceedButtonText}
            onClick={onProceed}
            color="primary"
            className="flex-1 ml-2 bg-primary text-white"
            isActive={true}
            data-testid={`button-${proceedButtonText
              .toLowerCase()
              .replace(/\s+/g, "-")}`}
          />
        </div>
      </div>
    </Modal>
  );
};

Delete.propTypes = {
  isVisible: PropTypes.bool,
  onClose: PropTypes.func,
  onProceed: PropTypes.func,
  header: PropTypes.string,
  paragraph: PropTypes.string,
  proceedButtonText: PropTypes.string,
  cancelButtonText: PropTypes.string,
};

export default Delete;
